// extracted by mini-css-extract-plugin
export var animating = "BottomBar-module--animating--426b6";
export var bottomBar = "BottomBar-module--bottomBar--196d3";
export var emerceLogo = "BottomBar-module--emerceLogo--29f83";
export var hide = "BottomBar-module--hide--929e1";
export var logo = "BottomBar-module--logo--bb428";
export var partnerLogos = "BottomBar-module--partnerLogos--f7501";
export var trustpilot = "BottomBar-module--trustpilot--57ab6";